import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttachmentsService {

  constructor(private http: HttpClient) { }

  getAttachments(documentId) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/list`, {
      id: documentId
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    });
	}
	deleteAttachment(idFile, path:string) {
    return this.http.post(`${environment.apiUrl}/${path}/attachment/delete`, {
      id: idFile
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }


  uploadMultipleTemp(data): Observable<any> {
      return this.http.post(`${environment.apiUrl}/trackvision/attachment/uploadMultipleTemp`, data, {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
      });
  }

  downloadAttachments(idReq, path:string) {
    return this.http.post(`${environment.apiUrl}/${path}/attachment/downloadAll`, {
      id: idReq
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  /** Devuelve URL firmada S3 del attachment (POST /attachment/get). */
  getAttachmentDownloadUrl(id: number): Observable<any> {
    return this.http.post(
      `${environment.apiUrl}/trackvision/attachment/get`,
      { id },
      {
        headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
      }
    );
  }

  getEditUrl(attachmentId: number, mode: string = 'edit') {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/editUrl`, {
      id: attachmentId,
      mode
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  getEditHistory(attachmentId: number) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/editHistory`, {
      id: attachmentId
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  updateCategory(attachmentId: number, category: string, categoryother?: string | null) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/updateCategory`, {
      id: attachmentId,
      category,
      categoryother: categoryother || null
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  /** Sube el adjunto al Google Drive del usuario (convertido a formato Google si aplica). */
  sendToDrive(attachmentId: number) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/sendToDrive`, {
      id: attachmentId
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  /** Estado de conexión + enlaces de Drive de todos los adjuntos del requerimiento, en una sola llamada. */
  getDriveLinks(requirementId: number) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/driveLinks`, {
      id: requirementId
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

  /** Trae los cambios desde Google Drive y pisa el adjunto en Inprovider (Fase 2). */
  pullFromDrive(attachmentId: number) {
    return this.http.post(`${environment.apiUrl}/trackvision/attachment/pullFromDrive`, {
      id: attachmentId
    }, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '')
    });
  }

}
